import fetch from '~~/common/js/universal/fetch';

const headers = { 'Content-Type': 'application/json; charset=utf-8' };

export default async ({ units, place, region, language }) => {
  const url = new URL(process.env.weatherApiUrl);
  url.searchParams.set('q', `${place},${region}`);
  if (language !== 'en') {
    url.searchParams.set('language', language);
  }
  url.searchParams.set('units', units === 'metric' ? 'm' : 'f');
  return fetch(url.toString(), { headers });
};
